import styled from '@emotion/styled'

// 常量定义
// 时间颜色
const TIMECOLOR = '#212121'
// 通用颜色
const COMMENLABELCOLOR = '#4C74B6'
// 标签颜色
const LABELCOLOR = '#EFA14B'
// 边框颜色
const BORDERCOLOR = '#F0F0F0'
// 详情颜色
const MORECOLOR = 'rgba(0,0,0,0.40)'
// 来源颜色
const SOURCECOLOR = '#8C8C8C'
// 重要title颜色
const IMPORTENTTTLECOLOR = '#E34D59'

const StyledItems = styled.div`
  width: 100%;
  cursor: pointer;
  padding: 2%;
  border-bottom: 1px solid ${BORDERCOLOR};
`
const StyleBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledCategory = styled.span`
  font-weight: 300;
  font-size: 13px;
  color: ${TIMECOLOR};
  float: left;
  width: 55px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const StyledTitlesName = styled.div`
  margin-left: 40px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  color: rgb(var(--ow-text-color));
`
const StyledTitles = styled.div`
  color: ${SOURCECOLOR};
  margin-top: 20px;
  font-size: 14px;
`
const StyledImportantTitles = styled.div`
  span:nth-child(1) {
    margin: 0 12px 0 40px;
  }
  text-align: left;
  font-size: 20px;
  font-weight: 600;
  color: ${IMPORTENTTTLECOLOR};
`
const StyledTimes = styled.span`
  font-size: 14px;
  font-weight: 200;
  color: ${TIMECOLOR};
  float: left;
`
const StyledDownload = styled.span`
  font-size: 14px;
  font-weight: 200;
  color: rgb(var(--ow-primary-color));
  float: right;
  margin-left: 10px;
`

const StyledLabels = styled.div`
  font-size: 13px;
  color: ${COMMENLABELCOLOR};
  margin: 10px 0px;
`
const StyledLabel = styled.div`
  font-size: 13px;
  color: ${LABELCOLOR};
  margin: 10px 0px;
`

const StyledSummarys = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  margin: 10px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
const StyledContent = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  margin: 10px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
`
const StyledDetails = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  color: ${MORECOLOR};
`
const StyledSource = styled.div`
  font-size: 12px;
  color: ${SOURCECOLOR};
`
const StyledLink = styled.div`
  color: ${SOURCECOLOR};
  font-size: 12px;
`

export {
  StyledItems,
  StyleBox,
  StyledCategory,
  StyledTitles,
  StyledTitlesName,
  StyledImportantTitles,
  StyledTimes,
  StyledLabels,
  StyledLabel,
  StyledSummarys,
  StyledContent,
  StyledDetails,
  StyledDownload,
  StyledSource,
  StyledLink,
}
